import { Task } from "@freeconvert/freeconvert-node/dist/types";
import { getFCUrl } from "client/utils/getFCUrl";
import { get } from "../Backend/get";
import { post } from "../Backend/post";
import { TaskService } from "../Task/TaskService";

export interface IDownloadServiceOptions {
    onError: (message: string) => void;
    onComplete: (task: Task) => void;
    filename: string;
}

export class DownloadService {
    private taskIds: string[];
    private options: IDownloadServiceOptions;
    private isComplete = false;

    public constructor(taskIds: string[], options: IDownloadServiceOptions) {
        this.taskIds = taskIds;
        this.options = options;

        this.createTask();
    }

    createTask = async () => {
        const { error, result } = await post<Task>(`${process.env.NEXT_PUBLIC_BE_URL}/tasks/export`, {
            input: this.taskIds,
            archive_multiple_files: true,
            filename: this.options.filename,
        });

        if (error || !result) {
            this.handleError(error?.message ?? "");
            return;
        }

        await this.subscribeToTaskService(result);
        this.checkStatus(result);
    };

    handleError = (message: string) => {
        this.options.onError(message);
    };

    subscribeToTaskService = async (task: Task) => {
        const taskService = new TaskService(task, {
            handleDisconnect: () => {},
            handleReconnect: () => {},
            handleTaskComplete: this.handleTaskComplete,
            handleTaskFail: (task) => {
                this.handleError(task.message);
            },
            onOfflineLimitReach: () => {},
        });
        await taskService.appendTask();
    };

    // private handleTaskComplete(task: Task) {
    handleTaskComplete = (task: Task) => {
        if (this.isComplete) return;
        this.isComplete = true;

        if (task.result?.url) {
            task.result.url = new URL(getFCUrl(task.result.url.toString()));
        }

        this.options.onComplete(task);
    };

    checkStatus = async (task: Task) => {
        const { error, result } = await get<Task>(`${process.env.NEXT_PUBLIC_BE_URL}/tasks/${task.id}`);

        if (error || !result) return;

        if (result.status === "completed") {
            this.handleTaskComplete(result);
        }

        return result.status === "completed";
    };
}
